
    import { C1_COLORS } from '@/C1Components/utils/variants';

    export default {
        name: 'C1Alert',

        props: {
            color: {
                type: String,
                default: 'cool-gray',
                validator: value => C1_COLORS.includes(value),
            },
        },

        computed: {
            classList() {
                return [
                    'text-body-3 rounded-8 px-3 py-2',
                    this.getColorClass,
                    this.getBgColorClass,
                    this.getBorderColorClass,
                ];
            },

            getColorClass() {
                const colors = {
                    'cool-gray': 'text-c1-cool-gray-400',
                    gray: 'text-c1-gray-400',
                    green: 'text-c1-green-400',
                    yellow: 'text-black',
                    red: 'text-c1-red-400',
                    blue: 'text-c1-blue-400',
                };

                return colors[this.color];
            },

            getBgColorClass() {
                const colors = {
                    'cool-gray': 'bg-c1-cool-gray-50',
                    gray: 'bg-c1-gray-50',
                    green: 'bg-c1-green-50',
                    yellow: 'bg-warning-500-opacity-15',
                    red: 'bg-c1-red-50',
                    blue: 'bg-c1-blue-50',
                };

                return colors[this.color];
            },

            getBorderColorClass() {
                const colors = {
                    'cool-gray': 'border-c1-cool-gray-400',
                    gray: 'border-c1-gray-400',
                    green: 'border-c1-green-400',
                    yellow: 'border-warning-500',
                    red: 'border-c1-red-400',
                    blue: 'border-c1-blue-400',
                };

                return `border-1 ${colors[this.color]}`;
            },
        },
    };
